import { isBreakpointMobile, useBreakpoint } from '@abdoo/common';
import { Box } from '@mui/material';
import React from 'react';

import { CalendarAnnualSummary } from '../calendar/CalendarAnnualSummary/CalendarAnnualSummary';
import { CalendarPlanner } from '../calendar/CalendarPlanner/CalendarPlanner';
import { HolidayBookingsModal } from '../calendar/HolidayBookingsModal';
import { SetupEntitlementDialog } from '../calendar/SetupEntitlementDialog/SetupEntitlementDialog';

interface AddAbsenceProps {
  isLoading: boolean;
  isPlannerLoading: boolean;
  plannerError: string;
}

export function AddAbsence({
  isLoading,
  isPlannerLoading,
  plannerError,
}: AddAbsenceProps) {
  const breakpoint = useBreakpoint();
  const isMobile = isBreakpointMobile(breakpoint);
  return (
    <Box>
      <CalendarPlanner
        plannerError={plannerError}
        isLoading={isPlannerLoading}
        currentDate={new Date()}
        addAbsence={true}
      />
      {!isMobile && <CalendarAnnualSummary isLoading={isLoading} addAbsence={true} />}
      <HolidayBookingsModal />
      <SetupEntitlementDialog />
    </Box>
  );
}
